import auth from '../../middlewares/auth';

export const shiftRoutes = [
  {
    path: '/shifts',
    component: () =>
      import(/* webpackChunkName: "shifts" */ '../../views/shifts/Shift'),
    name: 'shifts',
    meta: {
      middleware: [auth],
    },
  },
  {
    path: '/shifts-calendar',
    component: () =>
      import(
        /* webpackChunkName: "shifts" */ '../../views/shifts/ShiftCalendar'
      ),
    name: 'shifts-calendar',
    meta: {
      middleware: [auth],
    },
  },
  {
    path: '/working-shifts-calendar',
    component: () =>
      import(
        /* webpackChunkName: "shifts" */ '../../views/shifts/WorkingShiftCalendar'
      ),
    name: 'working-shifts-calendar',
    meta: {
      middleware: [auth],
    },
  },
  {
    path: '/shift/:id',
    component: () =>
      import(/* webpackChunkName: "shifts" */ '../../views/shifts/ShiftForm'),
    name: 'update-shift',
    meta: {
      middleware: [auth],
    },
  },
  {
    path: '/create-shift',
    component: () =>
      import(/* webpackChunkName: "shifts" */ '../../views/shifts/ShiftForm'),
    name: 'create-shift',
    meta: {
      middleware: [auth],
    },
  },
];
